import UIButton from 'UIComponents/button/UIButton';
import styled, { css } from 'foundations-theming-specialty/utils';
import { BreezeTertiaryAIBaseButton } from './StyledAIBaseButton';
const DropdownButtonIconStyle = css([".uiDropdown__buttonContents{display:inline-block;.uiDropdown__buttonLabel{margin-right:0.5rem;}}"]);
const IconStyle = css([".ai-icon{position:relative;}"]);
export const BreezeLinkOnDarkCopilotBaseButton = styled(UIButton).withConfig({
  displayName: "StyledCopilotBaseButton__BreezeLinkOnDarkCopilotBaseButton",
  componentId: "sc-1au4pty-0"
})(["border-radius:2rem !important;border:none !important;color:", " !important;text-decoration:none !important;&:not(.disabled) .ai-icon,&:not(.disabled) span{transition:all 150ms ease-out !important;color:", " !important;}&:not(.disabled):hover .ai-icon,&:not(.disabled):hover span{color:", " !important;}&:active{color:", " !important;}&.disabled,&[aria-disabled='true']{background:", " !important;color:", " !important;.ai-icon,span{color:", " !important;}}", " ", ""], ({
  theme
}) => theme.color['fill-surface-default'], ({
  theme
}) => theme.color['fill-surface-default'], ({
  theme
}) => theme.color['breeze-fill-loading-dot-default'], ({
  theme
}) => theme.color['breeze-fill-special-btn-alt-default'], ({
  theme
}) => theme.color['fill-primary-disabled'], ({
  theme
}) => theme.color['breeze-text-component-disabled'], ({
  theme
}) => theme.color['breeze-text-component-disabled'], DropdownButtonIconStyle, IconStyle);
export const BreezeTransparentCopilotBaseButton = styled(UIButton).withConfig({
  displayName: "StyledCopilotBaseButton__BreezeTransparentCopilotBaseButton",
  componentId: "sc-1au4pty-1"
})(["border-radius:2rem !important;border:none !important;color:", " !important;text-decoration:none !important;&:not(.disabled) .ai-icon,&:not(.disabled) span{transition:all 150ms ease-out !important;color:", " !important;}&:not(.disabled):hover .ai-icon,&:not(.disabled):hover span{color:", " !important;}&:active{color:", " !important;}&.disabled,&[aria-disabled='true']{background:", " !important;color:", " !important;.ai-icon,span{color:", " !important;}}", " ", ""], ({
  theme
}) => theme.color['text-core-default'], ({
  theme
}) => theme.color['text-core-default'], ({
  theme
}) => theme.color['breeze-fill-primary-hover'], ({
  theme
}) => theme.color['breeze-fill-special-btn-alt-default'], ({
  theme
}) => theme.color['fill-primary-disabled'], ({
  theme
}) => theme.color['breeze-text-component-disabled'], ({
  theme
}) => theme.color['breeze-text-component-disabled'], DropdownButtonIconStyle, IconStyle);

/** These styles are specific to Copilot Action Button
 * These Copilot inovations are different than standard AIButtons
 */
export const getStyledCopilotButton = use => {
  switch (use) {
    case 'transparent':
      return BreezeTransparentCopilotBaseButton;
    case 'link-on-dark':
      return BreezeLinkOnDarkCopilotBaseButton;
    case 'tertiary':
      return BreezeTertiaryAIBaseButton;
    default:
      return BreezeTransparentCopilotBaseButton;
  }
};